import React, { useState } from 'react';

import { Button, Dialog as MuiDialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import generateId from '../../utils/generateId';
import { WarningButton } from '../CustomMui';

export const Dialog = (props) => {
  const [id] = useState(generateId('dialog-'));
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button 
        onClick={handleOpen}
        {...props.openButtonProps}
      >
        {props.openButtonLabel}
      </Button>
      <MuiDialog
        open={open}
        onClose={handleClose}
        aria-labelledby={`${id}-title`}
        aria-describedby={`${id}-description`}
      >
        <DialogTitle id={`${id}-title`}>{props.primaryText}</DialogTitle>
        

        { props.secondaryText ? 
          <DialogContent>
            <DialogContentText id={`${id}-description`} component="div">
              {props.secondaryText}
            </DialogContentText>
          </DialogContent>
        : '' }

        <DialogActions>
          <Button onClick={handleClose} variant="text">
            Cancel
          </Button>
          {props.actionButton.warning ? 
            <WarningButton onClick={props.actionButton.action} autoFocus>
              {props.actionButton.label}
            </WarningButton>
          :
            <Button onClick={props.actionButton.action} color="primary" autoFocus>
              {props.actionButton.label}
            </Button>
          }
        </DialogActions>

      </MuiDialog>
    </>
  )
}